import axios from '@/api'

export default {
  namespaced : true,
  state : {
    orders : {
      orders : [],
      pagination : {
        page: 1,
        limit: 10,
        total: 0,
        pages: 0,
        prev: null,
        next: null
      }
    },
    currentPage : 1,
  },
  getters : {

  },
  mutations : {
    SET_ORDERS(state, payload){
      state.orders = payload;
    },
    SET_CURRENT_PAGE(state, payload){
      state.currentPage = payload;
    }
  },
  actions: {
    fetchOrders({ commit },payload){
      return new Promise((resolve, reject) => {
        let url = '';
        switch (payload.type) {
          case 'trip':
            url = `/admin/trips/${payload.trip_id}/orders/`;
            delete payload.trip_id;
            break;
          case 'customer':
            url = `/admin/customers/${payload.customer_id}/orders/`;
            delete payload.customer_id;
            break;
          default:
            url = `/admin/orders/`;
            break;
        }
        delete payload.type;

        if(payload.page){
          commit('SET_CURRENT_PAGE', payload.page);
          payload.sort = "-created_at";
          payload.pagination = {page: payload.page, limit: 10};
          delete payload.page;
        }

        axios.post(url, payload)
          .then((response) => {
            commit('SET_ORDERS', response.data);
            resolve(response.data)
          })
          .catch((error) => { reject(error) })
      })
    },
  },
}
